import { fetcher } from '@/utils/http';
import { logError } from '@/utils/log';

import { LocationState } from '../interfaces';

export const getAreas = async (
  geom: string,
  signal: AbortSignal
): Promise<LocationState[]> => {
  try {
    const data = await fetcher<LocationState[]>(
      `/api/location/search-for-alert?geom=${encodeURIComponent(geom)}`,
      { signal }
    );
    return data || [];
  } catch (error) {
    if (signal && !signal.aborted) {
      logError('Failed to get areas', { error });
    }
    return [];
  }
};
